/* Barra di ricerca (snippet df-search): pannello dei suggerimenti al clic, risultati mentre scrivi. */
if (!customElements.get('df-search')) {
  customElements.define('df-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.df-search__input');
      this.panel = this.querySelector('.df-search__panel');
      this.idle = this.querySelector('.df-search__idle');
      this.results = this.querySelector('.df-search__results');
      this.clear = this.querySelector('.df-search__clear');
      this.backdrop = this.querySelector('.df-search__backdrop');
      document.body.appendChild(this.backdrop);
      this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
      this.searchUrl = this.dataset.searchUrl || '/search';
      this.timer = null; this.ctrl = null; this.cache = {};
      this.input.addEventListener('focus', () => this.open());
      this.input.addEventListener('input', () => { if (!this.hasAttribute('open')) this.open(); else this.onInput(); });
      this.input.addEventListener('click', () => this.open());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.clear.addEventListener('click', () => { this.input.value = ''; this.onInput(); this.input.focus(); });
      this.backdrop.addEventListener('click', () => this.close());
      this.querySelector('.df-search__close').addEventListener('click', () => { this.close(); this.input.blur(); });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.hasAttribute('open')) { this.close(); this.input.blur(); } });
      this.clear.hidden = !this.input.value;
    }
    open() {
      if (this.hasAttribute('open')) return;
      const header = this.closest('.header-wrapper') || this.closest('header');
      if (header) this.style.setProperty('--df-search-top', header.getBoundingClientRect().bottom + 'px');
      this.setAttribute('open', '');
      this.panel.hidden = false; this.backdrop.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.onInput();
    }
    close() {
      this.removeAttribute('open');
      this.panel.hidden = true; this.backdrop.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
    onInput() {
      const q = this.input.value.trim();
      this.clear.hidden = !q;
      clearTimeout(this.timer);
      if (q.length < 2) { this.idle.hidden = false; this.results.hidden = true; return; }
      this.timer = setTimeout(() => this.fetch(q), 180);
    }
    onKey(e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const box = this.results.hidden ? this.idle : this.results;
      const items = [...box.querySelectorAll('a')];
      if (!items.length) return;
      e.preventDefault();
      let i = items.findIndex((a) => a.getAttribute('aria-selected') === 'true');
      items.forEach((a) => a.removeAttribute('aria-selected'));
      i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? items.length - 1 : i - 1);
      items[i].setAttribute('aria-selected', 'true');
      items[i].scrollIntoView({ block: 'nearest' });
      this.input.addEventListener('keydown', function go(ev) { if (ev.key === 'Enter') { ev.preventDefault(); items[i].click(); } }, { once: true });
    }
    async fetch(q) {
      if (this.cache[q]) return this.render(q, this.cache[q]);
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      const p = new URLSearchParams({ q: q, 'resources[type]': 'query,product,collection,article,page', 'resources[limit]': '6',
        'resources[limit_scope]': 'each', 'resources[options][unavailable_products]': 'last' });
      try {
        const r = await fetch(this.root + 'search/suggest.json?' + p.toString(), { signal: this.ctrl.signal });
        if (!r.ok) throw new Error(r.status);
        const d = (await r.json()).resources.results;
        await this.principale(q, d.products || [], this.ctrl.signal);
        this.cache[q] = d;
        this.render(q, d);
      } catch (err) { if (err.name !== 'AbortError') this.render(q, {}); }
    }
    // Shopify a volte sceglie una variante che con la ricerca non c'entra (es. "forno" -> il kit del Beta 2,
    // trovato per la descrizione della foto): se nessuna parola cercata è nel nome della variante,
    // mostro foto, prezzo e link della variante principale del prodotto
    async principale(q, prods, signal) {
      const parole = q.toLowerCase().split(/\s+/).filter((w) => w.length > 2);
      await Promise.all(prods.map(async (x) => {
        const v = x.variants && x.variants.length === 1 ? x.variants[0] : null;
        if (!v || parole.some((w) => String(v.title || '').toLowerCase().indexOf(w) > -1)) return;
        try {
          const r = await fetch(this.root + 'products/' + x.handle + '.js', { signal: signal });
          if (!r.ok) return;
          const pj = await r.json();
          const pv = pj.variants.find((y) => y.available) || pj.variants[0];
          if (pj.featured_image) x.featured_image = { url: pj.featured_image.indexOf('//') === 0 ? 'https:' + pj.featured_image : pj.featured_image };
          x.variants = [{ title: pv.title, price: (pv.price / 100).toFixed(2) }];
          const u = new URL(x.url, location.origin); u.searchParams.delete('variant'); x.url = u.pathname + u.search;
        } catch (e) { if (e.name === 'AbortError') throw e; }
      }));
    }
    money(v) {
      const n = parseFloat(v);
      return isNaN(n) ? '' : '€' + n.toFixed(2).replace('.', ',');   // come nel resto del sito: €10,05
    }
    esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
    render(q, d) {
      if (this.input.value.trim() !== q) return;
      const all = this.searchUrl + '?q=' + encodeURIComponent(q);
      const queries = (d.queries || []).slice(0, 5);
      const colls = (d.collections || []).slice(0, 4);
      const pages = [].concat(d.pages || [], d.articles || []).slice(0, 3);
      const prods = (d.products || []).slice(0, 5);
      let side = '';
      if (queries.length) side += '<div><span class="df-search__label">Ricerche suggerite</span><ul class="df-search__list">' +
        queries.map((x) => '<li><a href="' + this.esc(x.url) + '">' + (x.styled_text || this.esc(x.text)) + '</a></li>').join('') + '</ul></div>';
      if (colls.length) side += '<div class="df-search__links"><span class="df-search__label">Categorie</span>' +
        colls.map((x) => '<a href="' + this.esc(x.url) + '">' + this.esc(x.title) + '</a>').join('') + '</div>';
      if (pages.length) side += '<div class="df-search__links"><span class="df-search__label">Guide e pagine</span>' +
        pages.map((x) => '<a href="' + this.esc(x.url) + '">' + this.esc(x.title) + '</a>').join('') + '</div>';
      let main = '<div class="df-search__head"><span class="df-search__label">Prodotti</span></div>';
      if (prods.length) {
        main += '<div class="df-search__rows">' + prods.map((x) => {
          const img = x.featured_image && x.featured_image.url ? x.featured_image.url : (x.image || '');
          const src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          // se la ricerca ha trovato una sola variante il link porta lì: mostro il suo prezzo
          const v = x.variants && x.variants.length === 1 ? x.variants[0] : null;
          const da = !v && x.price_min && x.price_max && x.price_min !== x.price_max ? 'da ' : '';
          const title = String(x.title || '').split(' —')[0].replace(' Colorobbia', '');
          return '<a class="df-search__row" href="' + this.esc(x.url) + '">' + (src ? '<img src="' + this.esc(src) + '" alt="" loading="lazy" width="56" height="56">' : '') +
            '<span class="df-search__row-t">' + this.esc(title) + '</span><span class="df-search__price">' + da + this.money(v ? v.price : (x.price_min || x.price)) + '</span></a>';
        }).join('') + '</div>';
      } else {
        main += '<p class="df-search__empty">Nessun prodotto per "' + this.esc(q) + '". Prova con un altro nome o con il codice, oppure scrivici su WhatsApp.</p>';
      }
      main += '<div class="df-search__foot"><span>Scrivi anche un codice: TFF 1505, SLA 472</span><a class="df-search__all" href="' + this.esc(all) + '">Vedi tutti i risultati per "' + this.esc(q) + '"</a></div>';
      this.results.innerHTML = '<div class="df-search__res">' + (side ? '<div class="df-search__col df-search__col--side">' + side + '</div>' : '') +
        '<div class="df-search__col df-search__col--main">' + main + '</div></div>';
      this.idle.hidden = true; this.results.hidden = false;
    }
  });
}
